import { useNavigate } from 'react-router-dom';

const MODES = [
    {
        emoji:    '🧩',
        title:    'Krzyżówka',
        desc:     'Wpisuj słówka w kratkę, łącząc je ze sobą.',
        route:    '/crossword-config',
        color:    '#2563eb',
        colorBg:  '#eff6ff',
        colorBorder: '#bfdbfe',
    },
    {
        emoji:    '🔍',
        title:    'Wykreślanka',
        desc:     'Znajdź ukryte słówka w siatce liter.',
        route:    '/wordsearch-config',
        color:    '#2563eb',
        colorBg:  '#eff6ff',
        colorBorder: '#bfdbfe',
    },
];

export default function HomeScreen() {
    const navigate = useNavigate();

    return (
        <div style={styles.wrapper}>
            <div style={styles.inner}>
                <h1 style={styles.title}>Wybierz tryb gry</h1>
                <p style={styles.subtitle}>Ćwicz słówka w wybranej formie.</p>

                <div style={styles.grid}>
                    {MODES.map(mode => (
                        <button
                            key={mode.route}
                            style={{
                                ...styles.card,
                                backgroundColor: mode.colorBg,
                                border: `2px solid ${mode.colorBorder}`,
                            }}
                            onClick={() => navigate(mode.route)}
                            onMouseOver={e => e.currentTarget.style.transform = 'translateY(-4px)'}
                            onMouseOut={e  => e.currentTarget.style.transform = 'translateY(0)'}
                        >
                            <div style={styles.emoji}>{mode.emoji}</div>
                            <div style={{ ...styles.cardTitle, color: mode.color }}>
                                {mode.title}
                            </div>
                            <div style={styles.cardDesc}>{mode.desc}</div>
                            <div style={{ ...styles.cta, backgroundColor: mode.color }}>
                                Zagraj →
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

const styles = {
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #a4a5ff 0%, #8cb8ff 100%)',
        padding: '40px 20px',
        fontFamily: "'Segoe UI', Roboto, sans-serif",
    },
    inner: {
        textAlign: 'center',
        width: '100%',
        maxWidth: '700px',
    },
    title: {
        fontSize: '32px',
        fontWeight: '800',
        color: '#fff',
        margin: '0 0 8px',
        textShadow: '0 2px 8px rgba(0,0,0,0.15)',
    },
    subtitle: {
        fontSize: '16px',
        color: 'rgba(255,255,255,0.85)',
        margin: '0 0 40px',
    },
    grid: {
        display: 'flex',
        gap: '24px',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        padding: '36px 32px',
        borderRadius: '20px',
        cursor: 'pointer',
        width: '240px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        outline: 'none',
    },
    emoji: {
        fontSize: '52px',
        lineHeight: 1,
    },
    cardTitle: {
        fontSize: '22px',
        fontWeight: '800',
    },
    cardDesc: {
        fontSize: '14px',
        color: '#64748b',
        lineHeight: '1.5',
    },
    cta: {
        marginTop: '8px',
        padding: '10px 22px',
        borderRadius: '10px',
        color: '#fff',
        fontWeight: '700',
        fontSize: '15px',
    },
};
